import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

export const setOriginalQueryOnTypeSectionRedesignMutator: (
    tableView: TableView,
    isEnabled: boolean
) => void = mutatorAction(
    'setOriginalQueryOnTypeSectionRedesign',
    (tableView: TableView, isEnabled: boolean): void => {
        tableView.isOriginalQueryOnTypeSectionRedesignEnabled = isEnabled;
    }
);
